module.exports = "/_next/static/images/CombineData@3x-c7ff2806c194f1f805404eb4dab62f72.webp";